export const API_URL = import.meta.env.VITE_API_URL ?? ""

function formatApiError(error, fallbackStatus) {
  const detail = error?.detail ?? error?.message

  if (Array.isArray(detail)) {
    return detail
      .map((item) => {
        const location = Array.isArray(item.loc) ? item.loc.join('.') : item.loc
        return [location, item.msg].filter(Boolean).join(': ')
      })
      .join('; ')
  }

  if (typeof detail === 'string') return detail
  if (detail && typeof detail === 'object') {
    try {
      return JSON.stringify(detail)
    } catch {
      return `HTTP ${fallbackStatus}`
    }
  }

  return `HTTP ${fallbackStatus}`
}

// API client for making requests to the backend
export const client = {
  // Base fetch wrapper with error handling
  async fetch(endpoint, options = {}) {
    const url = `${API_URL}${endpoint}`
    const token = localStorage.getItem('authToken')
    const response = await fetch(url, {
      headers: {
        'Content-Type': 'application/json',
        ...(token && { 'Authorization': `Bearer ${token}` }),
        ...options.headers,
      },
      ...options,
    })

    if (!response.ok) {
      const error = await response.json().catch(() => ({ detail: 'Request failed' }))
      throw new Error(formatApiError(error, response.status))
    }

    return response.json()
  },

  // GET request
  async get(endpoint) {
    return this.fetch(endpoint)
  },

  // POST request
  async post(endpoint, data) {
    return this.fetch(endpoint, {
      method: 'POST',
      body: JSON.stringify(data),
    })
  },

  // PUT request
  async put(endpoint, data) {
    return this.fetch(endpoint, {
      method: 'PUT',
      body: JSON.stringify(data),
    })
  },

  // DELETE request
  async delete(endpoint) {
    return this.fetch(endpoint, {
      method: 'DELETE',
    })
  },

  // AI recommendations
  ai: {
    recommendations: () => client.get('/ai/recommendations'),
    analyze: (data) => client.post('/ai/analyze', data),
  },

  // ERP data
  erp: {
    data: () => client.get('/erp/data'),
    sync: () => client.post('/erp/sync', {}),
  },

  // Health check
  health: () => client.get('/health'),
}

export default client
